import { Chip as BaseChip, styled, Tooltip as BaseTooltip, tooltipClasses, TooltipProps } from "@mui/material";

export const Tooltip = styled(({ className, ...props }: TooltipProps) => <BaseTooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontWeight: 400,
    fontSize: theme.typography.size.small,
    padding: theme.spacing(1),
  },
}));

export const Chip = styled(BaseChip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  fontWeight: 700,
  fontSize: theme.typography.size.small,
  height: 24,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  borderRadius: 24,
}));
